import React from 'react';
import { Collapse } from 'react-collapse';

interface PROPS {
    error: string | undefined | false
    isSpecialError?: boolean
}

const ShowError: React.FC<PROPS> = ({ error, isSpecialError }) => {
    return (
        <Collapse isOpened={!!error}>
            <small className={isSpecialError ? "errorTextSpecial" : "errortext"}>{error}</small>
        </Collapse>
    )
}

export default React.memo(ShowError);